<p>Choose a date range for your report. Only games with a draw date within provided date range will be considered in the report</p>
<form [formGroup]="comprehensiveDatesFromGroup">
  <mat-form-field class="full-width">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate placeholder="Start date" formControlName="startDate" data-testid="date-range-report-start-date-input">
      <input matEndDate placeholder="End date" formControlName="endDate" data-testid="date-range-report-end-date-input">
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker" data-testid="date-range-report-datepicker-toggle"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
    <mat-error>Date Range is required</mat-error>
  </mat-form-field>
</form>

<div class="d-flex flex-column gap-3 margin-top-med">
  <div class="d-flex justify-content-end">
    <button mat-raised-button (click)="onSubmit()" data-testid="date-range-report-generate-button">
      Generate Reports
    </button>
  </div>

  @if (showReports) {
    <mat-tab-group dynamicHeight disableRipple data-testid="multi-draw-report-tab-group">
      <mat-tab
        label="Comprehensive Game Report"
        *hasPermission="permissionTypes.ViewComprehensiveGameReport"
        data-testid="comprehensive-report-tab">

        <app-comprehensive-report-by-date-range
          [dateRangesSetter]="dateRanges">
        </app-comprehensive-report-by-date-range>
      </mat-tab>

      <mat-tab
        label="Sales Summary by Price Point"
        *hasPermission="permissionTypes.ViewSalesSummaryByPricePointReport"
        data-testid="sales-by-price-point-tab">

        <app-price-point-report
          [dateRangesSetter]="dateRanges">
        </app-price-point-report>
      </mat-tab>

      <mat-tab
        label="Standard Game Reports"
        *hasPermission="permissionTypes.ViewGameSummaryReportByDateRange"
        data-testid="standard-game-report-by-date-range-tab">
        <app-multiple-standard-game-reports
          [dateRangesSetter]="dateRanges">
        </app-multiple-standard-game-reports>
      </mat-tab>
    </mat-tab-group>
  }
</div>

